angular
    .module("app")
    .factory("DownloadXmlService", function(
        HttpHelper,
        $browser,
        $window,
        $httpParamSerializer,
        toastr
    ) {
        var fac = {
            downloadXml: downloadXml,
            downloadZip: downloadZip
        };
        var numTracesForRequest = function(traceSummaryRequest) {
            return HttpHelper.post(
                "api/Download/NumTracesForRequest",
                traceSummaryRequest
            ).then(function(response) {
                return response;
            });
        };
        function downloadXml(traceSummaryRequest) {
            // Copy traceSummaryRequest
            var tsr = angular.copy(traceSummaryRequest);
            tsr.Take = 0;
            // Find out if we have any traces
            numTracesForRequest(tsr).then(function(response) {
                if (response.data === 0) {
                    toastr.warning("There are no traces for this request.");
                    return;
                }
                // If we do then download them
                var params = $httpParamSerializer(tsr);
                var url = "api/Download/SessionXml?" + params;
                $window.location.href = url;
                // TODO: Create file name using request data
                toastr.info("File downloaded");
            });
        }
        function downloadZip(traceSummaryRequest) {
            // Copy traceSummaryRequest
            var tsr = angular.copy(traceSummaryRequest);
            tsr.Take = 0;
            // Find out if we have any traces
            numTracesForRequest(tsr).then(function(response) {
                if (response.data === 0) {
                    toastr.warning("There are no traces for this request.");
                    return;
                }
                // If we do then download them
                var params = $httpParamSerializer(tsr);
                var url = "api/Download/SessionZip?" + params;
                $window.location.href = url;
                // TODO: Create file name using request data
                toastr.info("File downloaded");
            });
        }
        return fac;
    });
//# sourceMappingURL=download-xml.service.js.map
